import StorePreview from "../components/StorePreview";
import "./StoresList.css";
import { useEffect, useState } from "react";
import conf from "../config.json";
import { getCategories } from "../Map";
import { useLocation } from "react-router-dom";

export default function StoresList({
  location,
  map,
  mapView,
  dataSource,
  selectedCategories,
  selectedTags,
  setSelectedStore,
}) {
  const type = new URLSearchParams(useLocation().search).get("type");

  const [stores, setStores] = useState([]);
  const [results, setResults] = useState(true);

  const storesService = new woosmap.map.StoresService();
  const localitiesService = new woosmap.map.LocalitiesService();

  useEffect(() => {
    search(location, selectedCategories, selectedTags);
  }, [location, selectedCategories, selectedTags]);

  const selectStore = (store) => {
    mapView.setSelection(store);

    map.flyTo({
      center: {
        lat: store.geometry.coordinates[1],
        lng: store.geometry.coordinates[0],
      },
      zoom: 13,
      duration: 800, // optional animation duration in ms
    });
    setSelectedStore(store);
  };

  const categoryFilter = (categories) => {
    let q = window.woosmap.map.query;

    const selectedCategoriesQuery = categories.reduce((acc, category) => {
      acc.push(q.F("type", category));
      return acc;
    }, []);
    if (selectedCategories.length <= 0) {
      return getCategories(type);
    }
    // query = q.or([...selectedCategoriesQuery]);
    return selectedCategoriesQuery;
  };

  const tagsFilter = (tags) => {
    let q = window.woosmap.map.query;
    const selectedTagsQuery = tags.reduce((acc, tag) => {
      acc.push(q.F("tag", tag));
      return acc;
    }, []);
    // query = q.or([...selectedCategoriesQuery]);
    return selectedTagsQuery;
  };

  const search = (location, selectedCategories, selectedTags) => {
    if (location) {
      //Get Categories Filter
      const selectedCategoriesQuery = categoryFilter(selectedCategories);
      const selectedTagsQuery = tagsFilter(selectedTags);
      let q = window.woosmap.map.query;
      let query;
      if (selectedCategoriesQuery.length > 0 && selectedTagsQuery.length > 0) {
        query = q.and([
          q.or([...selectedCategoriesQuery]),
          q.or([...selectedTagsQuery]),
        ]);
      } else if (
        selectedCategoriesQuery.length <= 0 &&
        selectedTagsQuery.length > 0
      ) {
        query = q.or([...selectedTagsQuery]);
      } else if (
        selectedCategoriesQuery.length > 0 &&
        selectedTagsQuery.length <= 0
      ) {
        query = q.or([...selectedCategoriesQuery]);
      }
      //   const query = q.and([...selectedCategoriesQuery, ...selectedTagsQuery]);

      const storeSearchParams = {
        latLng: {
          lat: location.lat,
          lng: location.lng,
        },
        page: 1,
        storesByPage: conf.storesByPage,
        query:
          selectedCategoriesQuery.length > 0 || selectedTagsQuery.length > 0
            ? query
            : "",
      };

      handleGeoCode(storeSearchParams);
    } else {
      setStores([]);
    }
  };

  const handleGeoCode = (storeSearchParam) => {
    const latLng = {
      lat: storeSearchParam.latLng.lat,
      lng: storeSearchParam.latLng.lng,
    };
    localitiesService.geocode({ latLng }).then((localities) => {
      const location = localities.results[0]?.geometry?.location;
      if (!location) return;
      storesService
        .search(storeSearchParam)
        .then((nearbyStores) => {
          if (nearbyStores.features && nearbyStores.features.length <= 0) {
            setResults(false);
          }

          setStores(nearbyStores.features);
        })
        .catch((err) => console.log("Store Search Error:", err));
    });
  };

  return stores.length > 0 ? (
    <section className="storesList">
      {stores.map((store) => (
        <div
          className="columns container is-vcentered is-centered"
          key={store.properties.store_id}
          onClick={() => selectStore(store)}
        >
          <StorePreview
            name={store.properties.name}
            address={store.properties.address}
            distance={store.properties.distance}
          />
        </div>
      ))}
    </section>
  ) : (
    stores.length <= 0 && !results && <NoResult />
  );
}

const NoResult = () => {
  return (
    <section className="storesList">
      <div className="columns container is-vcentered is-centered">
        <p> Nessun risultato per questa ricerca</p>
      </div>
    </section>
  );
};
